import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import QRCode from "qrcode.react";
import { getQuery } from "@/service/http";
import { useStores } from "@/store";
import { Footer } from "@/components";
import icon1 from "./images/book.svg";
import icon2 from "./images/week.svg";
import icon3 from "./images/deal.svg";
import icon4 from "./images/notice.svg";
import store_apple from "./images/store_apple.svg";
import store_google from "./images/store_google.svg";
import store_360 from "./images/store_360.svg";
import store_tencent from "./images/store_tencent.svg";
import store_baidu from "./images/store_baidu.svg";
import store_mi from "./images/store_mi.svg";
import "./index.less";
import DownloadBtn from "@/components/download-btn";

// Mobile device detection
const isMobile = {
  Android: function () {
    return navigator.userAgent.match(/Android/i) ? true : false;
  },
  BlackBerry: function () {
    return navigator.userAgent.match(/BlackBerry/i) ? true : false;
  },
  IOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i) ? true : false;
  },
  Windows: function () {
    return navigator.userAgent.match(/IEMobile/i) ? true : false;
  },
  any: function () {
    return (
      isMobile.Android() ||
      isMobile.BlackBerry() ||
      isMobile.IOS() ||
      isMobile.Windows()
    );
  },
};

// App store URLs
const url_ios = "https://itunes.apple.com/app/diningcity/id1016748536";
const url_android =
  "https://play.google.com/store/apps/details?id=asia.diningcity.android";

const Download = () => {
  return (
    <section className="page-download-app">
      <DownloadDesktop />
      <DownloadMobile />
      <Footer isFixed={true} />
    </section>
  );
};

const DownloadDesktop = () => {
  const { t } = useTranslation();
  const lang = getQuery().lang || "en";
  const isZh = lang === "zh";
  const downloadLinks = isZh
    ? [
        { label: "App Store", href: url_ios, icon: store_apple },
        {
          label: "Google Play",
          href: "https://play.google.com/store/apps/details?id=asia.diningcity.android",
          icon: store_google,
        },
        {
          label: "360商店",
          href: "http://zhushou.360.cn/detail/index/soft_id/4024467?recrefer=SE_D_%E9%BC%8E%E9%A3%9F%E8%81%9A",
          icon: store_360,
        },
        {
          label: "腾讯商店",
          href: "https://sj.qq.com/myapp/detail.htm?apkName=asia.diningcity.android",
          icon: store_tencent,
        },
        {
          label: "百度商店",
          href: "https://shouji.baidu.com/software/25517188.html",
          icon: store_baidu,
        },

        {
          label: "小米商店",
          href: "http://app.mi.com/details?id=asia.diningcity.android",
          icon: store_mi,
        },
      ]
    : [
        { label: "Apple", href: url_ios, icon: store_apple },
        { label: "Android", href: url_android, icon: store_google },
      ];
  const cards = [
    {
      icon: icon1,
      title: t("Download.book_top_restaurants"),
      desc: t("Download.book_top_restaurants_desc"),
    },
    {
      icon: icon2,
      title: t("Download.rw_specials"),
      desc: t("Download.rw_specials_desc"),
    },
    {
      icon: icon3,
      title: t("Download.dining_deals"),
      desc: t("Download.dining_deals_desc"),
    },
    {
      icon: icon4,
      title: t("Download.never_miss"),
      desc: t("Download.never_miss_desc"),
    },
  ];
  return (
    <div className="download-app-desktop">
      <div className="download-app--body">
        <div className="download-app--main">
          <h1 className="download-app--main-title">
            {t("Download.discover_and_book")}
          </h1>
          <p className="download-app--main-desc">{t("Download.subtitle")}</p>
          <div className="download-app--main-btns">
            <div className="download-app--main-btns-qrcode">
              <QRCode size={160} value={window.location.href} />
              <span>{t("Download.Scan QR code")}</span>
            </div>
            <div className="download-app--main-btns-list">
              {downloadLinks.map((link, index) => (
                <a
                  key={index}
                  className="download-app--btn"
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={link.icon} alt={link.label} />
                  <span>{link.label}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="download-app--aside">
          <img src="/move.gif" alt="Desktop App" width={400} />
        </div>
      </div>
      <div className="download-app--list">
        {cards.map((card, index) => (
          <div className="download-app--item" key={index}>
            <div className="download-app--item-icon">
              <img src={card.icon} alt="" />
            </div>
            <div className="download-app--item-title">{card.title}</div>
            <div className="download-app--item-desc">{card.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
const DownloadMobile = () => {
  const { t } = useTranslation();
  const [footerDetail, setFooterDetail] = React.useState({});
  const { CommonStore } = useStores();
  useEffect(() => {
    const { region_id, region, regionId } = getQuery();
    CommonStore.getFooterDetail(region_id || regionId || region).then(
      (data) => {
        setFooterDetail(data);
      },
    );
  }, []);
  return (
    <>
      <div className="download-app-mobile">
        <div className="download-app-mobile--head">
          <img
            src={footerDetail?.web_logo}
            style={{ width: "100%" }}
            alt="Logo"
          />
        </div>
        <div className="download-app-mobile--body">
          <div className="download-app-mobile--title">
            {t("Download.discover_and_book")}
          </div>
          <div className="download-app-mobile--desc">
            {t("Download.subtitle")}
          </div>
          <div className="download-app-mobile--gif">
            <img src="/move.gif" alt="Mobile App" />
          </div>
          <DownloadBtn></DownloadBtn>
        </div>
      </div>
    </>
  );
};
export default Download;
